import {Component, inject, ViewContainerRef} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {ToastService} from "./core/service/toast.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent {
    private readonly toastService = inject(ToastService);
    private readonly viewContainerRef = inject(ViewContainerRef);

    title = 'napsu';

    constructor() {
        this.toastService.provideViewRef(this.viewContainerRef);
    }
}
